import * as React from 'react';
import { Route, Switch } from 'react-router';
import "./scss/main.css";
import { login } from './components/login';
import { registration } from './components/registration';
import NavMenu from './components/NavMenu';
import CustomerBills from './components/grids/CustomerBills';
import { Welcome } from './components/Welcome';
import { Reset } from './components/Reset';


export default () => (
    <>
        <Switch>            
            <Route path="/" component={NavMenu} />
        </Switch>
        <Switch>
            <Route exact path='/login' component={login} />
            <Route exact path='/logout' component={login} />
            <Route exact path='/registration' component={registration} />
            <Route exact path='/welcome' component={Welcome} />
            <Route exact path='/reset/' component={Reset} />
            <Route path='/' component={CustomerBills} />
        </Switch>
    </>
);
